import React, { useEffect, useRef } from "react";
import { drawBounds, drawIdealProfile, drawPoints, drawTicks } from "./ProfilePointUtils";

const ProfilePointsChart = ({ width, height, points, transformation, idealProfile, canvasOptions }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!canvasRef.current) return;

        const { left, right } = canvasOptions.padding;

        if (width - left - right < 0) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.clearRect(0, 0, width, height);

        //so this doesn't consider the start x and y, just the padding
        drawBounds(canvas, canvasOptions);
        drawTicks(canvas, canvasOptions);

        // drawPoint(canvas, canvasOptions, [40, 90]);
        // drawPoint(canvas, canvasOptions, [220, 90]);
        // drawPoint(canvas, canvasOptions, [40, 270]);
        // drawPoint(canvas, canvasOptions, [220, 270]);
        if (!points) return;

        drawPoints(canvas, canvasOptions, points);

        if (!idealProfile) return;
        drawIdealProfile(canvas, canvasOptions, idealProfile, transformation);
    }, [canvasOptions, height, idealProfile, points, transformation, width]);

    return (
        <canvas
            width={width}
            height={height}
            ref={canvasRef}
        />
    );
};

export default ProfilePointsChart;
